import React, { useState } from "react";
import visionLogo from "../../images/vision-logo.png";
import backImg from "../../images/back-img.png";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";

function ResetPassword() {
  const [password, setPassword] = useState("");
  const [cpassword, setCPassword] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [pwError, setPwError] = useState(false);
  const [cpwError, setCPwError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [isSuccess, setIsSuccess] = useState(false);

  function resetPassword(e) {
    e.preventDefault();
    setDisabled(true);
    let resetURL = process.env.REACT_APP_API_URL + "/reset-password/" + token;
    if (password == "") {
      setPwError(true);
      return false;
    } else if (cpassword) {
      setCPwError(true);
    }
    if (cpassword && password) {
      let payload = { Password: password };
      axios
        .post(resetURL, payload)
        .then((res) => {
          setDisabled(false);
          setIsSuccess(true);
        })
        .catch((err) => {
          setCPwError(false);
          let message =
            typeof err.response !== "undefined"
              ? err.response.data.message
              : "Somthing went wrong";
          setTimeout(() => {
            setDisabled(false);
          }, 500);
          setErrorMessage(message);
        });
    }
  }

  return (
    <section className="login" style={{ backgroundImage: `url(${backImg})` }}>
      <div className="login-container h-100">
        <div className="row justify-content-lg-end justify-content-center align-items-center h-100">
          <div className="width-xl-28 width-lg-55 width-md-80">
            <div className="card p-4 rounded-4">
              <div className="card-header bg-white border-0 text-center py-3">
                <img src={visionLogo} alt="" />
              </div>
              {!isSuccess ? (
                <div className="card-body">
                  <h6 className="card-title text-center title-bold fs-20 mb-1">
                    Reset Password
                  </h6>
                  <div className="spacer-2"></div>
                  <form onSubmit={resetPassword}>
                    <div className="mb-3">
                      <label
                        htmlFor="inputPw"
                        className="form-label fw-medium input-bold"
                      >
                        Password
                      </label>
                      <input
                        type="password"
                        className={
                          "form-control bg-green5 p-3 " +
                          (pwError ? " is-invalid" : "")
                        }
                        id="inputPw"
                        placeholder="Password"
                        onChange={(e) => {
                          setPwError(false);
                          setPassword(e.target.value);
                        }}
                      />
                    </div>
                    {errorMessage && (
                      <div className="text-danger text-center">
                        {" "}
                        {errorMessage}{" "}
                      </div>
                    )}
                    <div className="mb-3">
                      <label
                        htmlFor="inputcpw"
                        className="form-label fw-medium input-bold"
                      >
                        Confirm Password
                      </label>
                      <input
                        type="password"
                        className={
                          "form-control bg-green5 p-3 " +
                          (cpwError ? " is-invalid" : "")
                        }
                        id="inputcpw"
                        placeholder="Confirm Password"
                        onChange={(e) => {
                          setPwError(false);
                          setCPassword(e.target.value);
                          if (password != e.target.value) {
                            setCPwError(true);
                            setDisabled(true);
                          } else {
                            setCPwError(false);
                            setDisabled(false);
                          }
                        }}
                      />
                    </div>
                    {errorMessage && (
                      <div className="text-danger text-center">
                        {errorMessage}
                      </div>
                    )}
                    <div className="spacer-2"></div>
                    <div className="d-grid">
                      <button
                        disabled={disabled}
                        type="submit"
                        className="btn btn-primary btn-lg fw-medium text-white d-flex align-items-center justify-content-center"
                      >
                        Done
                      </button>
                    </div>
                  </form>
                  <Link
                    to="/"
                    className="fw-medium text-dark d-flex align-items-center justify-content-center"
                  >
                    Login
                  </Link>
                </div>
              ) : (
                <div className="card-body">
                  <h2 className="card-title text-center title-bold fs-32 mb-1">
                    Password Reset Successfully
                  </h2>
                  <p className="text-center fs-15 text-lite">
                    Congratulations! Your password has been changed
                    successfully.
                  </p>
                  <Link
                    to="/"
                    className="fw-medium text-dark d-flex align-items-center justify-content-center"
                  >
                    Login
                  </Link>
                </div>
              )}
              <div className="card-footer bg-white border-0 py-3">
                <p className="fs-13 text-center mb-0">
                  Copyright@2023. Vision Produce.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
export default ResetPassword;
